export const APPLY_URL = "https://calendly.com/dsaecommerce-sales/dsa-done-with-you-call";

export const PAYMENT_URL = "https://whop.com/dsa-ecommerce-llc/amazon-business-builder-program/";

export const SPRING = { type: "spring", stiffness: 100, damping: 20 };
